import { set } from 'lodash'

export const LIMITED_NUMBER_OF_UPLOADED_ITEMS = 15

export const processData = (importedColumns, importedData, matchingFields) => (
    importedData.map((e) => {
        const data: Record<string, any> = {}
        Object.entries(matchingFields).forEach((f) => {
            let data_column = e[importedColumns.indexOf(f[1])]
            if (typeof data_column === 'string') {
                data_column = data_column.trim()
            }
            set(data, f[0], data_column || '')
        })
        set(
            data,
            'delete',
            convertBooleanValue(e[importedColumns.findIndex((item) => item.toLowerCase() === 'delete')])
        )
        return data
    })
)

export const convertBooleanValue = (data) => /^[1yt]{1}$/i.test(data)

export const downloadErrorsFile = (errors) => {
    const data = new Blob([errors.join('\n')], { type: 'text/txt' })
    const csvURL = window.URL.createObjectURL(data)
    const tempLink = document.createElement('a')
    tempLink.href = csvURL
    tempLink.setAttribute('download', 'errors.txt')
    tempLink.click()
}

export const convertDateTimeForSubmitting = (data) => {
    if (data.startDate && data.startTime) {
        data.startDate.setHours(data.startTime.getHours())
        data.startDate.setMinutes(data.startTime.getMinutes())
        data.startDate.setSeconds(data.startTime.getSeconds())
        delete data.startTime
    }
    if (data.endDate && data.endTime) {
        data.endDate.setHours(data.endTime.getHours())
        data.endDate.setMinutes(data.endTime.getMinutes())
        data.endDate.setSeconds(data.endTime.getSeconds())
        delete data.endTime
    }
    return data
}

export const convertStringToList = (stringList = '') => (
    stringList.split(',').map((e) => e.trim()).filter((e) => !!e)
)
